export default __webpack_public_path__ + "static/media/members_icon_red.8716e4f5.svg";